"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.manualEntry_6_9 = void 0;
var utils_1 = require("@time-input-polyfill/utils");
var manualEntry_6_9 = function (utils) {
    var loadPrimaryInput = utils.loadPrimaryInput, a11yHasExpectedHtml = utils.a11yHasExpectedHtml, a11yInitialHtml = utils.a11yInitialHtml, hasReturnVal = utils.hasReturnVal;
    describe('Manual entry - 6-9', function () {
        var _loop_1 = function (i) {
            var hr24 = 12 + i;
            it("".concat(i, " ").concat(i, " A"), function () {
                loadPrimaryInput({ segment: 'hrs12' })
                    .type("".concat(i))
                    .should('have.value', "0".concat(i, ":30 PM"))
                    .then(a11yHasExpectedHtml(a11yInitialHtml().minutes))
                    .then(hasReturnVal("".concat(hr24, ":30")))
                    .type("".concat(i))
                    .should('have.value', "0".concat(i, ":0").concat(i, " PM"))
                    .then(a11yHasExpectedHtml(a11yInitialHtml().mode))
                    .then(hasReturnVal("".concat(hr24, ":0").concat(i)))
                    .type("a")
                    .should('have.value', "0".concat(i, ":0").concat(i, " AM"))
                    .then(a11yHasExpectedHtml('<p>AM.</p>'))
                    .then(hasReturnVal("".concat((0, utils_1.toLeadingZero)(hr24 - 12), ":0").concat(i)));
            });
        };
        for (var i = 6; i <= 9; i++) {
            _loop_1(i);
        }
    });
};
exports.manualEntry_6_9 = manualEntry_6_9;
